import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    DeletePopHover,
    Typography,
    Form,
    message,
    Modal,
    Input
} from "../../ui/ot";
import { Bar, BarChart, CartesianGrid, XAxis, LabelList, Brush } from "recharts"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
    ChartLegend, ChartLegendContent
} from "../../ui/chart"

const StackedColumnChart = ({
    //key 的 標籤及顯示顏色設定
    chartConfig = {
        desktop: {
            label: "Desktop",
            color: "hsl(var(--chart-1))",
        },
        mobile: {
            label: "Mobile",
            color: "hsl(var(--chart-2))",
        },
    },
    //data
    chartData = [
        { month: "January", desktop: 186, mobile: 80 },
        { month: "February", desktop: 305, mobile: 200 },
        { month: "March", desktop: 237, mobile: 120 },
        { month: "April", desktop: 73, mobile: 190 },
        { month: "May", desktop: 209, mobile: 130 },
        { month: "June", desktop: 214, mobile: 140 },
    ],
    //X 軸顯示的名稱得key
    xDataKeyArr = ["month"],
    //Y 軸顯示的名稱得key
    yDataKeyArr = ["desktop", 'mobile'],
    showLegend = true,
    showBrush = true

}) => {
    return (<Row>
        <Col span={24}>
            <ChartContainer config={chartConfig}>
                <BarChart accessibilityLayer data={chartData}>
                    <CartesianGrid vertical={false} />
                    {
                        xDataKeyArr.map((xDataKey) => (
                            <XAxis
                                dataKey={xDataKey}
                                tickLine={false}
                                tickMargin={10}
                                axisLine={false}
                                tickFormatter={(value) => value}
                            />
                        ))
                    }
                    <ChartTooltip content={<ChartTooltipContent hideLabel />} />
                    {showLegend && <ChartLegend
                        className="flex-wrap"
                        content={<ChartLegendContent indicator="line" />} />}
                    {
                        (yDataKeyArr || []).map((barKey, index) => {
                            if (index === 0) {
                                return (<Bar
                                    dataKey={barKey}
                                    fill={`var(--color-${barKey})`}
                                    radius={[0, 0, 4, 4]}
                                    stackId="a"
                                >

                                </Bar>)
                            }
                            else if (yDataKeyArr?.length - 1 === index) {
                                return (<Bar
                                    dataKey={barKey}
                                    fill={`var(--color-${barKey})`}
                                    radius={[4, 4, 0, 0]}
                                    stackId="a"
                                >
                                </Bar>)
                            }
                            else {
                                return (<Bar
                                    dataKey={barKey}
                                    fill={`var(--color-${barKey})`}
                                    stackId="a"
                                >

                                </Bar>)
                            }

                        })
                    }
                    {showBrush && <Brush
                        height={20}
                    />}
                </BarChart>
            </ChartContainer>
        </Col>
    </Row>)
}
export { StackedColumnChart }

